import * as React from 'react';
import { useContext, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import throttle from 'lodash/throttle';



import axios from "../../../utils/axios";




import { BrandContext } from "../../../contexts/BrandContext";
import { customLogger } from '../CustomLogger';

export default function ComboBox(props) {

  const [value, setValue] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');

  const brandContext = useContext(BrandContext);


  const {fieldProps,changeHandle} = props;

  const ref = useRef(null);


  const fetch = React.useMemo(
      () =>
          throttle((request, callback) => {
            const apiPath = `${process.env.REACT_APP_API_URL}${props.formFields[props.fieldName].apiLookupPath}${request.input}`;
            axios.get(apiPath,{
              timeout: 30000,
              withCredentials:true
            }).then(res => {
              callback(res.data);
            }).catch(err => {
              customLogger(err);
            });
          }, 200),
      [props],
  );

  React.useEffect(() => {

    if (document.activeElement.parentElement.parentElement === ref.current) {
    

      let active = true;
      const allowBlankLookup = (props.formFields[props.fieldName].allowBlankLookup === true);

      let existing = '';
      if(props.formik.values[props.fieldName]){
        existing = props.formFields[props.fieldName].optionTemplate(props.formik.values[props.fieldName])
      }

      if(inputValue !== existing){

        if (inputValue === '' && allowBlankLookup === false) {

            setOptions(value ? [value] : []);
          return undefined;
        }

        fetch({input: inputValue}, (results) => {

          if (active) {
            let newOptions = [];
            if (value && !results) {
              newOptions = [value];
            }

            if (results) {
              // console.log(results);
              newOptions = results;
            }

            setOptions(newOptions);
          }
        });
        return () => {
          active = false;
        };
      }
    }
    return undefined;

  }, [value, inputValue, fetch, props]);


    return (
    <Autocomplete
        
        filterOptions={(x) => x}
        {...fieldProps}
        onChange={(event, newValue) => {
          // setOptions(newValue ? [newValue, ...options] : options);
          setValue(newValue);
          props.formik.setFieldValue(props.fieldName,newValue);
          if(props.formFields[props.fieldName].onChangeHandler){
              props.formFields[props.fieldName].onChangeHandler(newValue);
          }
          if(changeHandle){
            changeHandle(newValue);
          }
        }}
        onInputChange={(event, newInputValue) => {
          
          setInputValue(newInputValue);
        }}
        value={props.formik.values[props.fieldName]}
      disablePortal
        getOptionLabel = {option => props.formFields[props.fieldName].optionTemplate(option)}
      id="combo-box-demo"
      options={options}
      loading
      renderInput={(params) => 
      <TextField 
          ref={ref}
          {...params} 
          label={props.fieldName in props.formFields ? brandContext.textContent[props.formFields[props.fieldName].label] : ''} 
        />}
    />
  );
}
